import { GenericApiResponse } from '@hevoio/hevo-ui-toolkit';
import { AppConfig } from '../../../core/app.config';
import { NetworkRequestOptions } from '../../../edge/request/interfaces/request-options';
import { hermesCourierService } from '../../../edge/request/services/hermes.courier.service';
import { SolutionRequest } from '../interfaces/query';
import { AIResponse } from '../interfaces/aiResponse';
const appConfig = new AppConfig();
export const ContactSupportAIAPI = {
  recommendationURL: appConfig.getRecommendationServiceURL(),
  authURL: appConfig.getSecurityServiceURL(),

  getSolution(params: SolutionRequest, networkOptions: NetworkRequestOptions): Promise<AIResponse> {
    const requestURL = `${this.recommendationURL}/retrieve`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showSuccessMsg: false,
        showErrorMsg: false
      },
      ...networkOptions
    };

    return hermesCourierService.post(requestURL, { query: params.issueDescription }, options);
  },

  createConversation(query: SolutionRequest): Promise<GenericApiResponse<{ conversation: string }>> {
    const requestURL = `${this.authURL}/users/zendesk-chat/support-query`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showSuccessMsg: false,
        showErrorMsg: true
      }
    };

    return hermesCourierService.post(requestURL, { symptom_area: query.entityType, symptom_reported: query.category, query: query.issueDescription }, options);
  },

  raiseTicket(query: SolutionRequest): Promise<GenericApiResponse<{ ticket: string }>> {
    const requestURL = `${this.authURL}/users/zendesk-chat/create-ticket`;

    const options: NetworkRequestOptions = {
      uiOptions: {
        showSuccessMsg: true,
        showErrorMsg: true
      }
    };

    return hermesCourierService.post(requestURL, { symptom_area: query.entityType, symptom_reported: query.category, query: query.issueDescription }, options);
  }
}